export default function getTodayISODate() {
  const today = new Date()
  const pad = (value) => String(value).padStart(2, '0')

  return [today.getFullYear(), pad(today.getMonth() + 1), pad(today.getDate())].join('-')
}
